import type { TrainingSimulatorTag } from "@/lib/training-simulator/message-tags";
import { GraduationCap } from "lucide-react";

export function TrainingSimulatorTagBadge({
  tag,
}: {
  tag: TrainingSimulatorTag;
}) {
  return <TrainingSimulatorBadge label={toTagLabel(tag)} />;
}

function TrainingSimulatorBadge({ label }: { label: string }) {
  return (
    <div className="flex w-fit items-center gap-1.5 rounded-full bg-amber-100 px-2.5 py-1 text-xs font-semibold text-amber-700">
      <GraduationCap className="h-3.5 w-3.5" />
      {label}
    </div>
  );
}

function toTagLabel(tag: TrainingSimulatorTag): string {
  switch (tag.kind) {
    case "feedback":
      return "Training Simulator feedback";
    case "question":
      const context = formatSimulatorContext(tag.modulePosition, tag.levelPosition);
      return `Training Simulator Question${context ? `: ${context}` : ""}`;
    default:
      return "";
  }
}

function formatSimulatorContext(
  modulePosition: number | null,
  levelPosition: number | null,
): string | null {
  const parts = [
    modulePosition ? `M${modulePosition}` : null,
    levelPosition ? `L${levelPosition}` : null,
  ].filter(Boolean);

  return parts.length > 0 ? parts.join(" ") : null;
}
